// Comparaison de numéros de version — copie assumée de server/utils/versionCompare.js.
//
// Duplication choisie, pas subie : la carte Applications a déjà toutes les
// lignes en mémoire, filtrer côté client répond à la frappe sans aller-retour
// réseau. Le serveur garde sa copie parce que l'endpoint `?versionBelow=` doit
// pouvoir servir un appelant qui n'est pas cette interface. Il n'existe pas de
// répertoire partagé entre le client CRA et le serveur dans ce projet — un
// import croisé sortirait de src/ et casserait la compilation.
//
// Une comparaison de CHAÎNES ne peut pas répondre à la question : « 7.10.0 »
// est inférieure à « 7.4.3 » en ordre lexicographique, alors que 7.10 est
// postérieure.

// Le contenu entre parenthèses est retiré : Intune renvoie « 3.7.72.6
// (377206130) », où le nombre entre parenthèses est un build interne qui
// écraserait les composantes qui le précèdent.
function composantes(version) {
    return String(version ?? '')
        .replace(/\([^)]*\)/g, ' ')
        .split(/[.\-\s,]+/)
        .filter(Boolean)
        .map((part) => {
            const nombre = parseInt(part, 10);
            return Number.isNaN(nombre) ? null : nombre;
        })
        .filter((n) => n !== null);
}

// Un build nu (« 797706504 ») n'est pas comparable à une version pointée
// (« 152.0.7977.75 ») : les deux formes coexistent pour un même logiciel sur le
// parc. Trancher conclurait que le build nu est supérieur, donc à jour — un
// poste en retard passerait pour conforme.
function estNumeroDeBuildNu(parts) {
    return parts.length === 1 && parts[0] >= 100000;
}

/**
 * `version` est-elle strictement inférieure à `cible` ?
 *
 * Une version absente ou non numérique compte comme INFÉRIEURE : « version
 * inconnue » est un cas à examiner, pas un cas à écarter.
 */
export function versionEstInferieure(version, cible) {
    const c = composantes(cible);
    if (c.length === 0) return false;

    const v = composantes(version);
    if (v.length === 0) return true;

    // Formats incomparables : traités comme une version inconnue, donc retenus.
    if (estNumeroDeBuildNu(v) !== estNumeroDeBuildNu(c)) return true;

    for (let i = 0; i < Math.max(v.length, c.length); i += 1) {
        const gauche = v[i] ?? 0;
        const droite = c[i] ?? 0;
        if (gauche < droite) return true;
        if (gauche > droite) return false;
    }
    return false;
}
